<link
  rel="stylesheet"
  href="https://use.fontawesome.com/releases/v5.7.0/css/all.css"
  integrity="sha384-lZN37f5QGtY3VHgisS14W3ExzMWZxybE1SJSEsQp9S+oqd12jhcu+A56Ebc1zFSJ"
  crossorigin="anonymous"
/>
<div class="container-fluid section-bg">
<div class="container pt-4 pb-3">
  <div class="row text-center">
    <div class="col">
      <i class="fas fa-mobile-alt fa-2x pb-3 pizza-icons"></i>
      <h4>Call us now</h4>
      <p>
        Order over the phone
        <span style="color: #a52a2a">+372 5555 9999</span>
      </p>
      <p>Sun-Thu 10.00 – 23.00 / Fri-Sat 10.00 – 24.00</p>
    </div>
    <div class="col">
      <i class="fas fa-laptop fa-2x pb-3 pizza-icons"></i>
      <h4>Online ordering</h4>
      <p>Order online</p>
      <p>
        <span style="color: #a52a2a"
          >Sun-Thu 10.00 – 23.00 / Fri-Sat 10.00 – 24.00</span
        >
      </p>
    </div>
    <div class="col">
      <i class="fas fa-car fa-2x pb-3 pizza-icons"></i>
      <h4>Cheapest delivery</h4>
      <p>Fast handcrafted pizza</p>
      <p>
        <span style="color: #a52a2a">Delivery starts at 2.00€</span>
      </p>
    </div>
  </div>
</div>
</div>
